/** Pre-generated random data pools to avoid bundling faker.js (~800 KB). */
export const uuids = [
    '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d',
    'f47ac10b-58cc-4372-a567-0e02b2c3d479',
    '1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bed',
    '6ba7b810-9dad-11d1-80b4-00c04fd430c8',
    'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    '550e8400-e29b-41d4-a716-446655440000',
    'c56a4180-65aa-42ec-a945-5fd21dec0538',
    '7c9e6679-7425-40de-944b-e07fc1f90ae7',
    'e4eaaaf2-d142-11e1-b3e4-080027620cdd',
    'aab5d5fd-70c1-11e5-a4fb-b026b977eb28',
    '2c5ea4c0-4067-11e9-8bad-9b1deb4d3b7d',
    'd9428888-122b-11e1-b85c-61cd3cbed5a2',
    'fb1a38e6-4be3-4e38-b8ec-c0c2c2d9e2a7',
    '01234567-89ab-cdef-0123-456789abcdef',
];
export const alphanumericChars = 'abcdefghijklmnopqrstuvwxyz0123456789';
export const hexColors = [
    '#e34f26',
    '#3498db',
    '#2ecc71',
    '#9b59b6',
    '#f1c40f',
    '#1abc9c',
    '#e74c3c',
    '#2c3e50',
    '#d35400',
    '#8e44ad',
    '#27ae60',
    '#c0392b',
    '#16a085',
    '#f39c12',
    '#7f8c8d',
];
export const abbreviations = [
    'HTTP',
    'SQL',
    'TCP',
    'JSON',
    'XML',
    'API',
    'SSL',
    'CSS',
    'HTML',
    'RAM',
    'FTP',
    'SSH',
    'DNS',
    'URL',
    'USB',
];
export const ipv4Addresses = [
    '192.168.1.42',
    '10.0.0.134',
    '172.16.254.1',
    '203.0.113.50',
    '198.51.100.23',
    '100.24.56.78',
    '54.239.28.85',
    '13.107.42.14',
    '151.101.1.140',
    '216.58.214.206',
    '93.184.216.34',
    '104.16.249.249',
    '172.217.14.206',
    '185.199.108.153',
    '140.82.121.4',
];
export const ipv6Addresses = [
    '2001:0db8:85a3:0000:0000:8a2e:0370:7334',
    'fe80:0000:0000:0000:0202:b3ff:fe1e:8329',
    '2607:f8b0:4004:0800:0000:0000:0000:200e',
    '2001:4860:4860:0000:0000:0000:0000:8888',
    '2a03:2880:f10c:0083:face:b00c:0000:25de',
    'fd12:3456:789a:1000:0000:0000:0000:0001',
    '2600:1f18:2489:8200:a953:2c7b:e7e0:d12f',
    '2001:0db8:0000:0042:0000:8a2e:0370:7334',
    'fe80:0000:0000:0000:4c5a:e8ff:fe7c:3d92',
    '2001:0db8:aaaa:bbbb:cccc:dddd:eeee:0001',
];
export const macAddresses = [
    '00:1A:2B:3C:4D:5E',
    'A4:83:E7:2D:6B:9F',
    '48:2C:6A:1E:59:3D',
    '00:50:56:C0:00:08',
    'D4:BE:D9:19:6F:F2',
    '3C:22:FB:4A:88:C1',
    '08:00:27:5B:8E:A4',
    'F0:18:98:43:65:DA',
    '5C:CF:7F:2B:1D:E3',
    '00:0C:29:3E:71:BC',
    '1C:6F:65:A2:8D:49',
    'B8:27:EB:63:4F:78',
];
export const locales = [
    'en',
    'es',
    'fr',
    'de',
    'it',
    'pt',
    'ja',
    'zh',
    'ko',
    'ar',
    'ru',
    'nl',
    'sv',
    'pl',
    'da',
    'fi',
    'nb',
    'tr',
    'hi',
    'th',
];
export const userAgents = [
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 14_2) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Safari/605.1.15',
    'Mozilla/5.0 (X11; Linux x86_64; rv:121.0) Gecko/20100101 Firefox/121.0',
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36 Edg/120.0.0.0',
    'Mozilla/5.0 (iPhone; CPU iPhone OS 17_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Mobile/15E148 Safari/604.1',
    'Mozilla/5.0 (Linux; Android 14; Pixel 8) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.6099.43 Mobile Safari/537.36',
    'Mozilla/5.0 (iPad; CPU OS 17_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Mobile/15E148 Safari/604.1',
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:121.0) Gecko/20100101 Firefox/121.0',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 14_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36',
    'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:121.0) Gecko/20100101 Firefox/121.0',
];
export const protocols = ['http', 'https'];
export const semvers = [
    '1.0.0',
    '2.3.1',
    '0.9.4',
    '3.12.0',
    '1.5.7',
    '4.0.0-beta.1',
    '0.1.0',
    '2.0.3',
    '1.2.0',
    '5.4.2',
    '3.1.0',
    '0.8.12',
    '2.7.5',
    '1.14.0',
    '6.0.0',
];
export const firstNames = [
    'Emma',
    'Liam',
    'Olivia',
    'Noah',
    'Ava',
    'James',
    'Sophia',
    'Oliver',
    'Isabella',
    'Lucas',
    'Mia',
    'Ethan',
    'Charlotte',
    'Mason',
    'Amelia',
];
export const lastNames = [
    'Smith',
    'Johnson',
    'Williams',
    'Brown',
    'Jones',
    'Garcia',
    'Miller',
    'Davis',
    'Rodriguez',
    'Martinez',
    'Hernandez',
    'Lopez',
    'Gonzalez',
    'Wilson',
    'Anderson',
];
export const namePrefixes = ['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Prof.', 'Rev.', 'Sir', 'Mx.'];
export const nameSuffixes = ['Jr.', 'Sr.', 'II', 'III', 'IV', 'PhD', 'MD', 'DDS', 'Esq.'];
export const jobAreas = [
    'Marketing',
    'Engineering',
    'Finance',
    'Operations',
    'Human Resources',
    'Sales',
    'Research',
    'Design',
    'Legal',
    'Product',
    'Data',
    'Support',
    'Quality',
    'Security',
    'Communications',
];
export const jobDescriptors = [
    'Senior',
    'Lead',
    'Junior',
    'Principal',
    'Chief',
    'Associate',
    'Global',
    'Regional',
    'Internal',
    'Dynamic',
    'Staff',
    'Executive',
    'National',
    'Strategic',
    'Corporate',
];
export const jobTitles = [
    'Software Engineer',
    'Product Manager',
    'Data Analyst',
    'UX Designer',
    'DevOps Engineer',
    'Marketing Director',
    'Sales Representative',
    'Financial Analyst',
    'Project Manager',
    'QA Engineer',
    'Technical Writer',
    'System Administrator',
    'Business Analyst',
    'Account Executive',
    'Operations Manager',
];
export const jobTypes = [
    'Full-time',
    'Part-time',
    'Contract',
    'Freelance',
    'Internship',
    'Temporary',
    'Remote',
    'Hybrid',
    'Consultant',
    'Seasonal',
];
export const phoneNumbers = [
    '(555) 123-4567',
    '(555) 987-6543',
    '(555) 246-8135',
    '(555) 369-2580',
    '(555) 741-8520',
    '(555) 852-9631',
    '(555) 147-2583',
    '(555) 963-8520',
    '(555) 321-6540',
    '(555) 654-9870',
    '(555) 789-0123',
    '(555) 234-5678',
    '(555) 876-5432',
    '(555) 468-1357',
    '(555) 531-2468',
];
export const cities = [
    'New York',
    'London',
    'Tokyo',
    'Paris',
    'Sydney',
    'Toronto',
    'Berlin',
    'Singapore',
    'Mumbai',
    'São Paulo',
    'Amsterdam',
    'Seoul',
    'Dublin',
    'Barcelona',
    'Melbourne',
];
export const streetNames = [
    'Main Street',
    'Oak Avenue',
    'Park Boulevard',
    'Cedar Lane',
    'Elm Drive',
    'Maple Court',
    'Pine Road',
    'Walnut Street',
    'Birch Avenue',
    'Cherry Lane',
    'Willow Way',
    'Spruce Circle',
    'Aspen Drive',
    'Hickory Place',
    'Chestnut Road',
];
export const streetAddresses = [
    '123 Main Street',
    '456 Oak Avenue',
    '789 Park Boulevard',
    '321 Cedar Lane',
    '654 Elm Drive',
    '987 Maple Court',
    '147 Pine Road',
    '258 Walnut Street',
    '369 Birch Avenue',
    '741 Cherry Lane',
    '852 Willow Way',
    '963 Spruce Circle',
    '159 Aspen Drive',
    '357 Hickory Place',
    '486 Chestnut Road',
];
export const countries = [
    'United States',
    'United Kingdom',
    'Canada',
    'Australia',
    'Germany',
    'France',
    'Japan',
    'Brazil',
    'India',
    'Netherlands',
    'South Korea',
    'Singapore',
    'Ireland',
    'Spain',
    'Sweden',
];
export const countryCodes = [
    'US',
    'GB',
    'CA',
    'AU',
    'DE',
    'FR',
    'JP',
    'BR',
    'IN',
    'NL',
    'KR',
    'SG',
    'IE',
    'ES',
    'SE',
    'IT',
    'NO',
    'DK',
    'FI',
    'CH',
];
export const latitudes = [
    '40.7128',
    '-33.8688',
    '51.5074',
    '35.6762',
    '48.8566',
    '-23.5505',
    '19.4326',
    '55.7558',
    '1.3521',
    '37.7749',
    '52.3676',
    '34.0522',
    '41.9028',
    '39.9042',
    '25.2048',
];
export const longitudes = [
    '-74.0060',
    '151.2093',
    '-0.1278',
    '139.6503',
    '2.3522',
    '-46.6333',
    '-99.1332',
    '37.6173',
    '103.8198',
    '-122.4194',
    '4.9041',
    '-118.2437',
    '12.4964',
    '116.4074',
    '55.2708',
];
export const avatarUrls = [
    'https://avatars.githubusercontent.com/u/12345678',
    'https://avatars.githubusercontent.com/u/23456789',
    'https://avatars.githubusercontent.com/u/34567890',
    'https://avatars.githubusercontent.com/u/45678901',
    'https://avatars.githubusercontent.com/u/56789012',
    'https://avatars.githubusercontent.com/u/67890123',
    'https://avatars.githubusercontent.com/u/78901234',
    'https://avatars.githubusercontent.com/u/89012345',
    'https://avatars.githubusercontent.com/u/90123456',
    'https://avatars.githubusercontent.com/u/10234567',
];
export const imageUrls = [
    'https://picsum.photos/seed/scalar1/640/480',
    'https://picsum.photos/seed/scalar2/640/480',
    'https://picsum.photos/seed/scalar3/640/480',
    'https://picsum.photos/seed/scalar4/640/480',
    'https://picsum.photos/seed/scalar5/640/480',
    'https://picsum.photos/seed/scalar6/640/480',
    'https://picsum.photos/seed/scalar7/640/480',
    'https://picsum.photos/seed/scalar8/640/480',
    'https://picsum.photos/seed/scalar9/640/480',
    'https://picsum.photos/seed/scalar10/640/480',
];
const flickrBase = 'https://loremflickr.com/640/480';
export const abstractImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/abstract?lock=${i + 1}`);
export const animalsImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/animals?lock=${i + 1}`);
export const businessImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/business?lock=${i + 1}`);
export const catsImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/cat?lock=${i + 1}`);
export const cityImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/city?lock=${i + 1}`);
export const foodImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/food?lock=${i + 1}`);
export const nightlifeImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/nightlife?lock=${i + 1}`);
export const fashionImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/fashion?lock=${i + 1}`);
export const peopleImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/people?lock=${i + 1}`);
export const natureImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/nature?lock=${i + 1}`);
export const sportsImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/sports?lock=${i + 1}`);
export const transportImageUrls = Array.from({ length: 10 }, (_, i) => `${flickrBase}/transport?lock=${i + 1}`);
export const dataUris = [
    'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2264%22%20height%3D%2264%22%3E%3Crect%20fill%3D%22%233498db%22%20width%3D%2264%22%20height%3D%2264%22%2F%3E%3C%2Fsvg%3E',
    'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2264%22%20height%3D%2264%22%3E%3Crect%20fill%3D%22%23e74c3c%22%20width%3D%2264%22%20height%3D%2264%22%2F%3E%3C%2Fsvg%3E',
    'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2264%22%20height%3D%2264%22%3E%3Crect%20fill%3D%22%232ecc71%22%20width%3D%2264%22%20height%3D%2264%22%2F%3E%3C%2Fsvg%3E',
    'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2264%22%20height%3D%2264%22%3E%3Crect%20fill%3D%22%239b59b6%22%20width%3D%2264%22%20height%3D%2264%22%2F%3E%3C%2Fsvg%3E',
    'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2264%22%20height%3D%2264%22%3E%3Crect%20fill%3D%22%23f1c40f%22%20width%3D%2264%22%20height%3D%2264%22%2F%3E%3C%2Fsvg%3E',
];
export const bankAccountNumbers = [
    '34042448',
    '34102758',
    '02997566',
    '52631809',
    '75412296',
    '37762776',
    '44117882',
    '13865687',
    '44377086',
    '74440091',
];
export const bankAccountNames = [
    'Personal Checking',
    'Savings Account',
    'Money Market',
    'Home Loan',
    'Auto Loan',
    'Investment Account',
    'Business Checking',
    'Credit Card',
    'Retirement Fund',
    'College Savings',
];
export const bicCodes = [
    'DEUTDEFF',
    'BNPAFRPP',
    'CHASUS33',
    'HSBCGB2L',
    'COBADEFF',
    'SCBLSGSG',
    'ANZBAU3M',
    'CITIUS33',
    'BOFAUS3N',
    'NWBKGB2L',
];
export const ibanNumbers = [
    'GB29NWBK60161331926819',
    'DE89370400440532013000',
    'FR7630006000011234567890189',
    'ES9121000418450200051332',
    'IT60X0542811101000000123456',
    'NL91ABNA0417164300',
    'CH9300762011623852957',
    'BE68539007547034',
    'AT611904300234573201',
    'FI2112345600000785',
];
export const transactionTypes = ['deposit', 'withdrawal', 'payment', 'invoice', 'transfer'];
export const currencyCodes = [
    'USD',
    'EUR',
    'GBP',
    'JPY',
    'AUD',
    'CAD',
    'CHF',
    'CNY',
    'INR',
    'BRL',
    'SEK',
    'NOK',
    'DKK',
    'SGD',
    'HKD',
];
export const currencyNames = [
    'US Dollar',
    'Euro',
    'British Pound',
    'Japanese Yen',
    'Australian Dollar',
    'Canadian Dollar',
    'Swiss Franc',
    'Chinese Yuan',
    'Indian Rupee',
    'Brazilian Real',
    'Swedish Krona',
    'Norwegian Krone',
    'Danish Krone',
    'Singapore Dollar',
    'Hong Kong Dollar',
];
export const currencySymbols = ['$', '€', '£', '¥', 'A$', 'C$', 'CHF', '¥', '₹', 'R$'];
export const bitcoinAddresses = [
    '1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa',
    '3J98t1WpEZ73CNmQviecrnyiWrnqRhWNLy',
    'bc1qw508d6qejxtdg4y5r3zarvary0c5xw7kv8f3t4',
    '1BvBMSEYstWetqTFn5Au4m4GFg7xJaNVN2',
    '3Kzh9qAqVWQhEsfQz7zEQL1EuSx5tyNLNS',
    '1FeexV6bAHb8ybZjqQMjJrcCrHGW9sb6uF',
    'bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
    '3FZbgi29cpjq2GjdwV8eyHuJJnkLtktZc5',
    '1P5ZEDWTKTFGxQjZphgWPQUpe554WKDfHQ',
    'bc1q42lja79elem0anu8q860g3milve2ycq5t8g3ux',
];
export const companyNames = [
    'Acme Corp',
    'Globex',
    'Initech',
    'Umbrella Industries',
    'Stark Enterprises',
    'Wayne Corp',
    'Cyberdyne Systems',
    'Tyrell Corp',
    'Soylent Corp',
    'Aperture Science',
    'Massive Dynamic',
    'Oscorp',
    'Abstergo',
    'Weyland-Yutani',
    'Hooli',
];
export const companySuffixes = ['Inc', 'LLC', 'Group', 'Ltd', 'PLC', 'Corp'];
export const buzzPhrases = [
    'leverage agile frameworks',
    'iterate revolutionary convergence',
    'drive seamless solutions',
    'enable viral e-services',
    'synergize scalable supply-chains',
    'harness real-time channels',
    'orchestrate integrated experiences',
    'deliver frictionless partnerships',
    'transform dynamic mindshare',
    'cultivate open-source communities',
];
export const buzzAdjectives = [
    'innovative',
    'scalable',
    'seamless',
    'cutting-edge',
    'robust',
    'synergistic',
    'dynamic',
    'holistic',
    'strategic',
    'disruptive',
    'frictionless',
    'proactive',
    'world-class',
    'collaborative',
    'granular',
];
export const buzzVerbs = [
    'leverage',
    'iterate',
    'synergize',
    'monetize',
    'orchestrate',
    'disintermediate',
    'harness',
    'incentivize',
    'optimize',
    'streamline',
    'revolutionize',
    'cultivate',
    'empower',
    'facilitate',
    'aggregate',
];
export const buzzNouns = [
    'frameworks',
    'paradigms',
    'synergies',
    'platforms',
    'infrastructures',
    'bandwidth',
    'channels',
    'communities',
    'convergence',
    'deliverables',
    'e-markets',
    'experiences',
    'initiatives',
    'interfaces',
    'methodologies',
];
export const catchPhrases = [
    'Adaptive zero defect data-warehouse',
    'Automated scalable protocol',
    'Business-focused zero defect hub',
    'Cloned responsive flexibility',
    'Cross-group background collaboration',
    'De-engineered stable conglomeration',
    'Distributed actuating throughput',
    'Enhanced client-server capability',
    'Face to face explicit superstructure',
    'Front-line multimedia interface',
];
export const catchPhraseAdjectives = [
    'Adaptive',
    'Advanced',
    'Automated',
    'Balanced',
    'Business-focused',
    'Centralized',
    'Cloned',
    'Configurable',
    'Cross-group',
    'Customizable',
    'De-engineered',
    'Decentralized',
    'Digitized',
    'Distributed',
    'Enhanced',
];
export const catchPhraseDescriptors = [
    '24 hour',
    'actuating',
    'analyzing',
    'asymmetric',
    'asynchronous',
    'background',
    'bandwidth-monitored',
    'bi-directional',
    'bifurcated',
    'bottom-line',
    'clear-thinking',
    'client-driven',
    'client-server',
    'coherent',
    'cohesive',
];
export const catchPhraseNouns = [
    'ability',
    'access',
    'algorithm',
    'alliance',
    'analyzer',
    'application',
    'approach',
    'architecture',
    'array',
    'attitude',
    'benchmark',
    'budgetary management',
    'capability',
    'capacity',
    'challenge',
];
export const databaseColumns = [
    'id',
    'name',
    'email',
    'status',
    'created_at',
    'updated_at',
    'description',
    'amount',
    'category',
    'token',
    'avatar',
    'phone',
    'address',
    'comment',
    'title',
];
export const databaseTypes = [
    'int',
    'varchar',
    'text',
    'boolean',
    'date',
    'timestamp',
    'float',
    'bigint',
    'json',
    'uuid',
    'decimal',
    'enum',
    'blob',
    'char',
    'smallint',
];
export const databaseCollations = [
    'utf8_general_ci',
    'utf8mb4_unicode_ci',
    'ascii_general_ci',
    'latin1_swedish_ci',
    'utf8_unicode_ci',
    'utf8mb4_general_ci',
    'utf8_bin',
    'latin1_general_ci',
    'utf8mb4_bin',
    'ascii_bin',
];
export const databaseEngines = [
    'InnoDB',
    'MyISAM',
    'MEMORY',
    'CSV',
    'ARCHIVE',
    'FEDERATED',
    'NDB',
    'MERGE',
    'BLACKHOLE',
    'EXAMPLE',
];
export const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export const domainNames = [
    'example.com',
    'test-site.org',
    'my-app.io',
    'dev-portal.net',
    'api-hub.com',
    'code-base.dev',
    'data-flow.co',
    'web-pulse.io',
    'cloud-nest.org',
    'tech-wave.net',
    'open-source.dev',
    'byte-craft.io',
    'pixel-lab.co',
    'node-spark.com',
    'vue-forge.dev',
];
export const domainSuffixes = ['com', 'org', 'net', 'io', 'dev', 'co', 'info', 'app', 'me', 'xyz'];
export const domainWords = [
    'example',
    'test-site',
    'my-app',
    'dev-portal',
    'api-hub',
    'code-base',
    'data-flow',
    'web-pulse',
    'cloud-nest',
    'tech-wave',
    'open-source',
    'byte-craft',
    'pixel-lab',
    'node-spark',
    'vue-forge',
];
export const emails = [
    'emma.smith@example.com',
    'liam.johnson@test.org',
    'olivia.williams@demo.io',
    'noah.brown@sample.net',
    'ava.jones@mail.com',
    'james.garcia@inbox.dev',
    'sophia.miller@webmail.co',
    'oliver.davis@post.io',
    'isabella.rodriguez@email.org',
    'lucas.martinez@connect.net',
    'mia.hernandez@hub.com',
    'ethan.lopez@office.dev',
    'charlotte.gonzalez@corp.io',
    'mason.wilson@biz.co',
    'amelia.anderson@pro.net',
];
export const exampleEmails = [
    'emma@example.com',
    'liam@example.org',
    'olivia@example.net',
    'noah@example.com',
    'ava@example.org',
    'james@example.net',
    'sophia@example.com',
    'oliver@example.org',
    'isabella@example.net',
    'lucas@example.com',
    'mia@example.org',
    'ethan@example.net',
];
export const usernames = [
    'emma_dev42',
    'liam.codes',
    'olivia_tech',
    'noah_builds',
    'ava.hacks',
    'james_ops',
    'sophia_data',
    'oliver.api',
    'isa_design',
    'lucas_vue',
    'mia_cloud',
    'ethan.stack',
    'char_pixel',
    'mason_byte',
    'amelia_net',
];
export const urls = [
    'https://example.com',
    'https://test-site.org',
    'https://my-app.io',
    'https://dev-portal.net',
    'https://api-hub.com',
    'https://code-base.dev',
    'https://data-flow.co',
    'https://web-pulse.io',
    'https://cloud-nest.org',
    'https://tech-wave.net',
    'https://open-source.dev',
    'https://byte-craft.io',
];
export const fileNames = [
    'report.pdf',
    'data.csv',
    'image.png',
    'backup.tar.gz',
    'readme.md',
    'config.yml',
    'schema.json',
    'styles.css',
    'app.tsx',
    'index.html',
    'notes.txt',
    'archive.zip',
    'log.xml',
    'script.sh',
    'database.sql',
];
export const fileTypes = [
    'application',
    'text',
    'image',
    'audio',
    'video',
    'font',
    'model',
    'multipart',
    'message',
    'chemical',
];
export const fileExtensions = [
    'pdf',
    'csv',
    'png',
    'json',
    'md',
    'yml',
    'html',
    'txt',
    'xml',
    'sql',
    'tar',
    'gz',
    'wasm',
    'webp',
];
export const commonFileNames = [
    'report.pdf',
    'photo.jpg',
    'document.docx',
    'spreadsheet.xlsx',
    'presentation.pptx',
    'image.png',
    'video.mp4',
    'audio.mp3',
    'archive.zip',
    'readme.txt',
];
export const commonFileTypes = ['text', 'application', 'image', 'audio', 'video'];
export const commonFileExtensions = [
    'pdf',
    'jpg',
    'png',
    'gif',
    'mp3',
    'mp4',
    'doc',
    'xls',
    'ppt',
    'txt',
    'zip',
    'html',
    'css',
    'js',
    'json',
];
export const filePaths = [
    '/home/user/documents/report.pdf',
    '/var/log/app/server.log',
    '/tmp/upload/image.png',
    '/opt/data/backup.tar.gz',
    '/home/user/projects/app/src/index.ts',
    '/etc/config/settings.yml',
    '/usr/local/bin/script.sh',
    '/home/user/downloads/archive.zip',
    '/var/www/html/index.html',
    '/home/user/.config/app.json',
];
export const directoryPaths = [
    '/home/user/documents',
    '/var/log/app',
    '/tmp/uploads',
    '/opt/data',
    '/home/user/projects/app/src',
    '/etc/config',
    '/usr/local/bin',
    '/home/user/downloads',
    '/var/www/html',
    '/home/user/.config',
];
export const mimeTypes = [
    'application/json',
    'text/html',
    'image/png',
    'application/pdf',
    'text/plain',
    'image/jpeg',
    'application/xml',
    'text/css',
    'application/javascript',
    'image/svg+xml',
    'application/zip',
    'audio/mpeg',
    'video/mp4',
    'font/woff2',
    'application/octet-stream',
];
export const products = [
    'Chair',
    'Computer',
    'Keyboard',
    'Mouse',
    'Table',
    'Phone',
    'Shoes',
    'Shirt',
    'Pants',
    'Hat',
    'Bike',
    'Towels',
    'Gloves',
    'Soap',
    'Tuna',
];
export const productAdjectives = [
    'Refined',
    'Elegant',
    'Rustic',
    'Gorgeous',
    'Practical',
    'Fantastic',
    'Handcrafted',
    'Incredible',
    'Licensed',
    'Sleek',
    'Intelligent',
    'Recycled',
    'Modern',
    'Bespoke',
    'Ergonomic',
];
export const productMaterials = [
    'Cotton',
    'Steel',
    'Wooden',
    'Concrete',
    'Rubber',
    'Granite',
    'Plastic',
    'Frozen',
    'Soft',
    'Metal',
    'Bronze',
    'Silk',
    'Leather',
    'Ceramic',
    'Bamboo',
];
export const productNames = [
    'Refined Cotton Chair',
    'Sleek Steel Computer',
    'Elegant Wooden Table',
    'Practical Rubber Keyboard',
    'Gorgeous Granite Mouse',
    'Rustic Metal Bike',
    'Handcrafted Silk Shirt',
    'Incredible Bamboo Towels',
    'Modern Leather Shoes',
    'Ergonomic Plastic Phone',
    'Fantastic Ceramic Soap',
    'Licensed Bronze Hat',
    'Intelligent Soft Gloves',
    'Bespoke Cotton Pants',
    'Recycled Steel Tuna',
];
export const departments = [
    'Electronics',
    'Clothing',
    'Books',
    'Home',
    'Garden',
    'Sports',
    'Toys',
    'Automotive',
    'Grocery',
    'Health',
    'Beauty',
    'Music',
    'Movies',
    'Games',
    'Outdoors',
];
export const nouns = [
    'server',
    'database',
    'network',
    'protocol',
    'system',
    'algorithm',
    'interface',
    'module',
    'component',
    'function',
    'framework',
    'library',
    'instance',
    'variable',
    'endpoint',
];
export const verbs = [
    'run',
    'build',
    'deploy',
    'parse',
    'fetch',
    'render',
    'compile',
    'stream',
    'cache',
    'merge',
    'sync',
    'push',
    'pull',
    'test',
    'debug',
];
export const ingVerbs = [
    'running',
    'building',
    'deploying',
    'parsing',
    'fetching',
    'rendering',
    'compiling',
    'streaming',
    'caching',
    'merging',
    'syncing',
    'pushing',
    'pulling',
    'testing',
    'debugging',
];
export const adjectives = [
    'fast',
    'secure',
    'scalable',
    'robust',
    'dynamic',
    'modular',
    'stable',
    'lightweight',
    'portable',
    'resilient',
    'efficient',
    'responsive',
    'concurrent',
    'stateless',
    'distributed',
];
export const words = [
    'pixel',
    'quantum',
    'cipher',
    'matrix',
    'vector',
    'nexus',
    'pulse',
    'flux',
    'forge',
    'prism',
    'vortex',
    'helix',
    'orbit',
    'spark',
    'nebula',
];
export const loremWords = [
    'lorem',
    'ipsum',
    'dolor',
    'sit',
    'amet',
    'consectetur',
    'adipiscing',
    'elit',
    'sed',
    'do',
    'eiusmod',
    'tempor',
    'incididunt',
    'ut',
    'labore',
    'et',
    'dolore',
    'magna',
    'aliqua',
    'enim',
];
export const loremSentences = [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
    'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.',
    'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.',
    'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.',
    'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet.',
    'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit.',
    'Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse.',
    'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis.',
];
export const loremParagraphs = [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
    'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.',
];
export const loremSlugs = [
    'lorem-ipsum-dolor',
    'sed-tempor-incididunt',
    'amet-consectetur-adipiscing',
    'eiusmod-labore-dolore',
    'veniam-nostrud-exercitation',
    'voluptate-velit-cillum',
    'occaecat-cupidatat-proident',
    'perspiciatis-omnis-natus',
    'aspernatur-odit-fugit',
    'dolorem-ipsum-amet',
];
